import { useDeviceType } from '@vfit/shared/hooks';
import { ITopHomeProps } from './newHeroSliderv2.models';
import NewHeroSliderDefaultV2 from './NewHeroSliderDefaultV2/newHeroSliderDefault';
import NewHeroSliderAnimationV2 from './NewHeroSliderAnimationV2/newHeroSliderAnimation';

const NewHeroSliderV2 = ({ slides, onTrack }: ITopHomeProps) => {
  const { isMobile } = useDeviceType();
  if (!slides || slides.length === 0) return null;
  const originalSlides = JSON.parse(JSON.stringify(slides || []));
  return (
    <>
      {isMobile && <NewHeroSliderDefaultV2 slides={originalSlides} onTrack={onTrack} />}
      {!isMobile && (
        <NewHeroSliderAnimationV2 slides={originalSlides?.reverse()} onTrack={onTrack} />
      )}
    </>
  );
};

export default NewHeroSliderV2;

